"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
var apollo_client_1 = require("apollo-client");
var apollo_link_1 = require("apollo-link");
var apollo_link_ws_1 = require("apollo-link-ws");
var apollo_upload_client_1 = require("apollo-upload-client");
var apollo_utilities_1 = require("apollo-utilities");
var react_apollo_1 = require("react-apollo");
var BaseProvider_1 = require("@gdp/react-app/lib/platforms/BaseProvider");
var ClientApolloProvider = /** @class */ (function (_super) {
    tslib_1.__extends(ClientApolloProvider, _super);
    function ClientApolloProvider(preloadedState, httpLinkOptions, wsLinkConfiguration, defaultOptions, reducerConfig, ssrForceFetchDelay, resolvers, initialData) {
        var _this = this;
        var cache = new apollo_cache_inmemory_1.InMemoryCache(reducerConfig).restore(preloadedState);
        var httpLink = apollo_upload_client_1.createUploadLink(httpLinkOptions);
        var wsLink = wsLinkConfiguration && new apollo_link_ws_1.WebSocketLink(wsLinkConfiguration);
        var link = wsLink
            ? apollo_link_1.split(function (_a) {
                var query = _a.query;
                var definition = apollo_utilities_1.getMainDefinition(query);
                return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
            }, wsLink, httpLink)
            : httpLink;
        _this = _super.call(this, new apollo_client_1.ApolloClient({
            cache: cache,
            defaultOptions: defaultOptions,
            ssrForceFetchDelay: ssrForceFetchDelay,
            link: link,
            resolvers: resolvers
        })) || this;
        if (initialData)
            cache.writeData(initialData);
        return _this;
    }
    ClientApolloProvider.prototype.component = function (children) {
        return React.createElement(react_apollo_1.ApolloProvider, { client: this.provider }, children);
    };
    return ClientApolloProvider;
}(BaseProvider_1.BaseProvider));
exports.ClientApolloProvider = ClientApolloProvider;
//# sourceMappingURL=ClientApolloProvider.js.map